<template>
    <div v-if="displayProperties">

        <h4 class="mb-4">Interested in similar offerings?</h4>

        <carousel v-if="uiStore.isMobile" :autoPlay="false" :controls="false" :active="mobileAciveSlide" @slide="(num) => mobileAciveSlide=num">
            <template #default>
                <property-common-card v-for="relatedProperty in displayProperties" :key="`property-${property.id}-properties-carousel-${relatedProperty.id}`" :property="relatedProperty" class="peek mx-1" :singleLineName="true" />
            </template>
            <template #footer>
                <carousel-indicators :active="mobileAciveSlide" @click="(num) => mobileAciveSlide=num">
                    <carousel-indicator-dot v-for="(relatedProperty, index) in displayProperties" :key="`property-${property.id}-properties-carousel-indicator-${relatedProperty.id}`" color="secondary" activeColor="primary" :active="mobileAciveSlide == index" size="sm"/>
                </carousel-indicators>
            </template>
        </carousel>
        <container v-else>
            <row>
                <column :md="12" :lg="8" v-for="relatedProperty in displayProperties" :key="`property-${property.id}-properties-list-${relatedProperty.id}`" class="pb-4">
                    <property-common-card class="h-100" :property="relatedProperty" />
                </column>
            </row>
        </container>
    </div>
</template>

<script type="text/javascript">

    import PropertyCommonCard from '@/components/Content/Public/Properties/Cards/Common.vue';
    import CommonComponents from '@/components/Common.vue';

    import ApiObject from '@/classes/ApiObject.js';
    import ApiConfig from '@/config/api.json';

    import { UseApiStore } from '@/store/Api.js';
    import { UseUIStore } from '@/store/UI.js';

    export default {
        components: {
            PropertyCommonCard,
            ...CommonComponents,
        },

        setup() {
            return {
                apiStore: UseApiStore(),
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                error: null,
                disposed: false,
                emptyResults: null,
                requestsTimer: null,
                
                mobileAciveSlide: 0,
                mobileAciveSlidePlaceholder: 0,
            };
        },

        created() {
            this.requestData();
        },

        beforeUnmount() {
            clearTimeout(this.requestsTimer);
            this.disposed = true;
        },

        props: {
            property: {
                type: ApiObject,
                required: true,
            },
        },

        computed: {

            requestUrl() {
                let url = 'properties/'+this.property.id+'/related-properties';
                return url;
            },

            properties() {
                let response = this.apiStore.requests[this.requestUrl];
                
                if (!response) {
                    return null;
                }

                if ((response.valid) && (response.results) && (!response.results.error)) {
                    if (response.results.length) {
                        return response.results;
                    }
                    else {
                        this.setEmptyResults(true);
                        return null;
                    }
                }
                else {
                    let error = 'Could not complete request';
                    if ((response.results) && (response.results.error)) {
                        if (response.results.error.message) error = response.results.error.message;
                        else error = response.results.error;
                    }
                    this.setError(error);
                }
                
                return null;
            },

            displayProperties() {
                if ((this.properties) && (this.properties.length)) {
                    let maxProperties = this.properties.length;

                    if (maxProperties > 4) {
                        if (this.uiStore.isTablet) {
                            maxProperties = 4;
                        }
                        else if (!this.uiStore.isMobile) {
                            maxProperties = 3;
                        }
                    }

                    let re = [];
                    for (let i=0; i<maxProperties; i++) {
                        re.push(this.properties[i]);
                    }

                    return re;
                }

                return null;
            },
        },

        methods: {

            async requestData() {
                if (this.disposed) return;
                
                this.setError(null);
                this.setEmptyResults(null);
                
                clearTimeout(this.requestsTimer);

                await this.apiStore.get(this.requestUrl);

                this.requestsTimer = setTimeout(this.requestData, ApiConfig.dashboardLongCache * 1000);
            },

            setError(error) {
                this.error = error;
            },
            
            setEmptyResults(val) {
                this.emptyResults = val;
            },
        }
    };

</script>
